<div>
  <h2 class="text-left font-serif !font-bold capitalize !text-2xl mb-2">
    Frequent questions
  </h2>
  <mat-expansion-panel
    class="text-left transparent-expansion-panel"
    (opened)="logEventOnce(GENERAL_EVENTS.faqWhyPrefundClicked)"
  >
    <mat-expansion-panel-header
      class="!p-0 !pr-[.2rem] !text-[.78rem] md:!text-base"
    >
      <mat-panel-title>💡 What is Prefund?</mat-panel-title>
    </mat-expansion-panel-header>
    <p class="mb-4">
      Prefund is a simple expense planner and tracker application that was built to help my family keep track of our expenses.
      
    </p>
    <p>
      It is a Progressive Web Application, which means you can install it on your phone or desktop and use it as a native application!
    </p>
  </mat-expansion-panel>
  <mat-expansion-panel
    class="text-left transparent-expansion-panel"
    (opened)="
      logEventOnce('faq-expanded-can-i-install-prefund-on-my-phone-or-desktop')
    "
  >
    <mat-expansion-panel-header
      class="!p-0 !pr-[.2rem] !text-[.78rem] md:!text-base"
    >
      <mat-panel-title
        >📱 Awesome, can I register?</mat-panel-title
      >
    </mat-expansion-panel-header>
    <p class="mb-4">
      Unfortunately, registration is not available. This application is meant for demo purposes only.
    </p>
    <p class="mb-4">
      You can however try the offline demo version and see how it works.
    </p>
    
  </mat-expansion-panel>
  <!-- <mat-expansion-panel
    class="text-left transparent-expansion-panel"
    (opened)="logEventOnce(GENERAL_EVENTS.faqIsFreeClicked)"
  >
    <mat-expansion-panel-header
      class="!p-0 !pr-[.2rem] !text-[.78rem] md:!text-base"
    >
      <mat-panel-title>🆓 Can I use Prefund for free?</mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Yes! Prefund offers a free version with unlimited entries for an unlimited
      time. You can always export your data, and when ready, you can subscribe
      to Prefund Pro.
    </p>
  </mat-expansion-panel> -->
  <!-- <mat-expansion-panel
    class="text-left transparent-expansion-panel"
    (opened)="logEventOnce(GENERAL_EVENTS.faqWhySubscribeClicked)"
  >
    <mat-expansion-panel-header
      class="!p-0 !pr-[.2rem] !text-[.78rem] md:!text-base"
    >
      <mat-panel-title
        >🤔 Why should I subscribe to Prefund Pro?</mat-panel-title
      >
    </mat-expansion-panel-header>
    <p class="mb-4">
      Prefund is made by a single developer - me, Gábor. I use the subscription
      fee to cover server costs and it motivates me to keep working on the
      product.
    </p>

    <p>
      With Prefund Pro, you get Periodic Tags, Archived Tags, more colors and
      priority support. Prefund Pro also offers a 100% refund within 30 days of
      purchase.
      <a
        href=""
        target="_blank"
        class="underline"
        (click)="logEventOnce(GENERAL_EVENTS.faqPricingLearnMoreClicked)"
        >Learn more</a
      >
    </p>
  </mat-expansion-panel> -->
  <!-- <mat-expansion-panel
    class="text-left transparent-expansion-panel"
    (opened)="logEventOnce(GENERAL_EVENTS.faqReadMoreClicked)"
  >
    <mat-expansion-panel-header
      class="!p-0 !pr-[.2rem] !text-[.78rem] md:!text-base"
    >
      <mat-panel-title>📣 Can I read more about the project?</mat-panel-title>
    </mat-expansion-panel-header>
    <p>
      Yes, we have a Featurebase site, where you can find our
      <a
        href=""
        target="_blank"
        class="underline"
        >Feedback forum</a
      >, our
      <a href="" target="_blank" class="underline"
        >Roadmap</a
      >
      and our
      <a href="" target="_blank" class="underline"
        >Help Center</a
      >.
    </p>
  </mat-expansion-panel> -->
</div>
